<div class="tickets-container">
  <div class="container-fluid">
    <div class="table-container">
      <div class="tickets-title">
        <h5>Tichete</h5>
      </div>
      <div class="table-responsive">
        <div class="date-picker">
          <form [formGroup]="form">
            <mat-form-field appearance="outline">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  formControlName="start"
                  #dateRangeStart
                  placeholder="Start date"
                />
                <input
                  matEndDate
                  formControlName="end"
                  #dateRangeEnd
                  placeholder="End date"
                  (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)"
                />
              </mat-date-range-input>
              <button
                mat-icon-button
                class="clear-button"
                *ngIf="isDateRangeSelected()"
                (click)="clearDateRange()"
              >
                <i class="bi bi-x"></i>
              </button>
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
                *ngIf="!isDateRangeSelected()"
              ></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
              <mat-error
                *ngIf="
                  form.get('dateRange.start')?.hasError('matStartDateInvalid')
                "
                >Invalid start date</mat-error
              >
              <mat-error
                *ngIf="form.get('dateRange.end')?.hasError('matEndDateInvalid')"
                >Invalid end date</mat-error
              >
            </mat-form-field>
          </form>
        </div>
        <table
          datatable
          [dtOptions]="dtOptions"
          class="table table-hover table-nowrap"
          id="ticketsDataTable"
        >
          <thead class="thead-light">
            <tr>
              <th scope="col" (click)="sortTable('firstName')">Nume</th>
              <th scope="col" (click)="sortTable('lastName')">Prenume</th>
              <th scope="col" (click)="sortTable('email')">E-mail</th>
              <th scope="col" (click)="sortTable('licensePlate')">
                Număr de înmatriculare
              </th>
              <th scope="col" (click)="sortTable('paymentType')">
                Operator de plată
              </th>
              <th scope="col" (click)="sortTable('zone')">Zona</th>
              <th scope="col" (click)="sortTable('duration')">Durata</th>
              <th scope="col" (click)="sortTable('startDate')">Data și ora</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</div>
